import { g as o } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as r, normalizeClass as n, createElementVNode as e } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconBluetoothOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(i).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = o();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], _ = ["clip-path"], f = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M.646.646a.5.5 0 0 1 .708 0L6.35 5.644a.542.542 0 0 1 .005.005l4.998 4.997a.5.5 0 0 1-.708.708L8.5 9.207l-2.146 2.147A.5.5 0 0 1 5.5 11V7.207L3.854 8.854a.5.5 0 1 1-.708-.708L5.293 6 .646 1.354a.5.5 0 0 1 0-.708ZM6.5 7.207v2.586L7.793 8.5 6.5 7.207ZM5.809.538a.5.5 0 0 1 .545.108l2.5 2.5a.5.5 0 0 1 0 .708l-1.25 1.25a.5.5 0 1 1-.708-.708l.897-.896L6.5 2.207V3.25a.5.5 0 1 1-1 0V1a.5.5 0 0 1 .309-.462Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  f
], p = ["id"], m = /* @__PURE__ */ e("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  m
];
function v(a, I, l, L, b, t) {
  return r(), d("svg", {
    "aria-label": l.ariaLabel,
    class: n([t.iconSizeClass, "d-icon d-icon--bluetooth-off"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Bluetooth Off",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`
    }, h, 8, _),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, g, 8, p)
    ])
  ], 10, u);
}
const B = /* @__PURE__ */ s(c, [["render", v]]);
export {
  B as default
};
//# sourceMappingURL=bluetooth-off.js.map
